import InfoCard from 'molecules/InfoCard';

export const cooperativeOptions = {
  gestureHandling: 'cooperative',
  disableDefaultUI: true,
  fullscreenControl: false,
  streetViewControl: true,
  streetViewControlOptions: {
    position: 8 // google.maps.ControlPosition.RIGHT_CENTER
  },
  mapTypeControl: false,
  zoomControl: false,
  OnMarkerClickListener: true,
  disableAutoPan: true
};

export const greedyOptions = {
  gestureHandling: 'greedy',
  disableDefaultUI: true,
  fullscreenControl: false,
  streetViewControl: true,
  streetViewControlOptions: {
    position: 8 // google.maps.ControlPosition.RIGHT_CENTER
  },
  mapTypeControl: false,
  zoomControl: false,
  OnMarkerClickListener: true,
  disableAutoPan: true
};

export const disabledOptions = {
  streetViewControl: false,
  mapTypeControl: false,
  zoomControl: false,
  fullscreenControl: false
};

export const locationMapProps = {
  mapOptions: disabledOptions,
  poiComponent: InfoCard,
  zoom: 15
};
